import React from "react";
import { motion } from "framer-motion";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import whyus1 from "../../assets/img/whyus_img1.png";
import whyus2 from "../../assets/img/whyus_img2.png";
import whyus3 from "../../assets/img/whyus_img3.png";
import whyus4 from "../../assets/img/whyus_img4.png";

const cardData = [
  {
    img: whyus1,
    title: "Large-Scale Operations",
  },
  {
    img: whyus2,
    title: "Reliable Fast Delivery",
  },
  {
    img: whyus3,
    title: "Pay Later Facilities",
  },
  {
    img: whyus4,
    title: "Customer Satisfaction",
  },
];

function WhyUs() {
  const theme = useTheme();
  return (
    <Box sx={{ padding: "2rem", marginTop: "5vh" }}>
      {/* Heading */}
      <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          color: theme.palette.secondary.main,
          mb: 4,
          fontWeight: "600",
          boxShadow: "0px 4px 4px 0px #00000000", // Adding box shadow
        }}
      >
        Why Us?
      </Typography>

      {/* Grid of Cards */}
      <Grid container spacing={4} justifyContent="center">
        {cardData.map((card, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around",
                width: "80%",
                boxShadow: "none",
              }}
            >
              {/* Card Image */}
              {index === 0 || index === 2 ? (
                <motion.div
                  animate={{
                    rotate: [-5, 5, -5], // Half-rotation back and forth
                    y: [-5, 5, -5], // Up and down movement
                  }}
                  transition={{
                    duration: 2, // Duration for one cycle
                    repeat: Infinity, // Infinite looping
                  }}
                >
                  <CardMedia
                    component="img"
                    image={card.img}
                    alt={card.title}
                    sx={{
                      width: "80%",
                      maxHeight: "80px",
                      objectFit: "contain",
                    }}
                  />
                </motion.div>
              ) : index === 1 ? (
                <motion.div
                  animate={{
                    x: [0, 40, 0], // Move left to right and back
                  }}
                  transition={{
                    duration: 2, // Animation cycle duration
                    repeat: Infinity, // Infinite looping
                  }}
                >
                  <CardMedia
                    component="img"
                    image={card.img}
                    alt={card.title}
                    sx={{
                      width: "80%",
                      maxHeight: "80px",
                      objectFit: "contain",
                    }}
                  />
                </motion.div>
              ) : index === 3 ? (
                <motion.div
                  animate={{
                    rotate: [0, 15, -15, 0], // Rotate back and forth
                    scale: [1, 1.3, 1], // Zoom in and out
                  }}
                  transition={{
                    duration: 3, // Animation cycle duration
                    repeat: Infinity, // Infinite looping
                  }}
                >
                  <CardMedia
                    component="img"
                    image={card.img}
                    alt={card.title}
                    sx={{
                      width: "80%",
                      maxHeight: "80px",
                      objectFit: "contain",
                    }}
                  />
                </motion.div>
              ) : (
                <CardMedia
                  component="img"
                  image={card.img}
                  alt={card.title}
                  sx={{
                    width: "80%",
                    maxHeight: "80px",
                    objectFit: "contain",
                  }}
                />
              )}

              {/* Card Content */}
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{
                    textAlign: "center",
                    color: "#5A5A5A", // Text color for title
                    fontWeight: "bold",
                  }}
                >
                  {card.title}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default WhyUs;
